import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import _JSXStyle from "styled-jsx/style";
import { ExpandableProductRow } from "./components/expandable-product-row";
import { expandableProductsPricing } from "./expandable-products-pricing-component.scss";
const DEFAULT_PRODUCT_NAMES = [
    "crm",
    "service",
    "software"
];
const ExpandableProductsPricingComponent = ({ productNames = DEFAULT_PRODUCT_NAMES, productTitles = {}, pricesAndFeaturesCardsPricing })=>{
    return /*#__PURE__*/ _jsxs("div", {
        className: `jsx-${expandableProductsPricing.__hash}` + " " + "expandable-products-pricing",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: `jsx-${expandableProductsPricing.__hash}` + " " + "products-list",
                children: productNames.map((productName)=>/*#__PURE__*/ _jsx(ExpandableProductRow, {
                        productName: productName,
                        productTitle: productTitles[productName],
                        pricesAndFeaturesCardsPricing: pricesAndFeaturesCardsPricing
                    }, productName))
            }),
            /*#__PURE__*/ _jsx(_JSXStyle, {
                id: expandableProductsPricing.__hash,
                children: expandableProductsPricing
            })
        ]
    });
};
export default ExpandableProductsPricingComponent;
